import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Heading, Link, Paragraph } from '@digdir/designsystemet-react';
import { CheckmarkCircleIcon } from '@navikt/aksel-icons';
import type { SafetyRepTask } from '../../../api/safetyRepWork';
import { Routes } from '../../../enums/Routes';
import { taskKey } from '../safetyRepWorkView';
import { TaskItem } from './TaskItem';
import layout from '../../HRDashboard/hmsPage.module.css';
import classes from '../SafetyRep.module.css';

/** The same tasks as on the page of tasks, the most urgent first */
export const TasksCard = ({
  tasks,
}: {
  tasks: SafetyRepTask[];
}): ReactElement => {
  const { t } = useTranslation();
  return (
    <section aria-labelledby="vo-needs" className={classes.section}>
      <div className={classes.cardHeading}>
        <div className={layout.cardHeading}>
          <Heading level={2} data-size="md" id="vo-needs">
            {t('safetyRep.work.needs.title')}
          </Heading>
          {tasks.length > 0 && (
            <Paragraph data-size="sm" className={layout.subtle}>
              {t('safetyRep.work.needs.help', { count: tasks.length })}
            </Paragraph>
          )}
        </div>
        {tasks.length > 0 && (
          <Link asChild data-size="sm">
            <RouterLink to={Routes.SafetyRepSigning}>
              {t('safetyRep.work.needs.all')}
            </RouterLink>
          </Link>
        )}
      </div>
      {tasks.length === 0 ? (
        <div className={classes.empty} role="status">
          <CheckmarkCircleIcon aria-hidden className={classes.emptyIcon} />
          <div className={classes.emptyText}>
            <span className="ds-label">{t('safetyRep.work.needs.none')}</span>
            <Paragraph data-size="sm" className={layout.subtle}>
              {t('safetyRep.work.needs.noneText')}
            </Paragraph>
          </div>
        </div>
      ) : (
        <ol className={classes.tasks}>
          {tasks.map((task, index) => (
            <li key={taskKey(task)}>
              <TaskItem task={task} primary={index === 0} />
            </li>
          ))}
        </ol>
      )}
    </section>
  );
};
